import { processOnWorker } from '@loaders.gl/worker-utils';
const VERSION = typeof "4.1.0-alpha.9" !== 'undefined' ? "4.1.0-alpha.9" : 'latest';
export const TriangulationWorker = {
  id: 'triangulation',
  name: 'Triangulate',
  module: 'arrow',
  version: VERSION,
  options: {}
};
export function triangulateOnWorker(data) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return processOnWorker(TriangulationWorker, {
    ...data,
    operation: 'triangulate'
  }, options);
}
export function parseGeoArrowOnWorker(data) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return processOnWorker(TriangulationWorker, {
    ...data,
    operation: 'parse-geoarrow'
  }, options);
}
//# sourceMappingURL=triangulate-on-worker.js.map